import { unescape } from 'es-toolkit';

const BR_REGEX = /<br\s*\/?>/g;
const TAGS_REGEX = /<[^>]+>/g;
const WHITE_SPACE_REGEX = /(\s*\r?\n\s*|\s\s+|&nbsp;)/g;
const DECIMAL_ENTITY_REGEX = /&#(\d+);/g;
const HEX_ENTITY_REGEX = /&#x([0-9a-f]+);/gi;

const decodeEntities = (string: string) => {
  return string
    .replace(DECIMAL_ENTITY_REGEX, (_, dec) => String.fromCodePoint(dec))
    .replace(HEX_ENTITY_REGEX, (_, hex) =>
      String.fromCodePoint(parseInt(hex, 16))
    );
};

export const htmlToText = (html: string) => {
  const sanitizedText = unescape(html)
    .replace(BR_REGEX, '\n')
    .replace(TAGS_REGEX, '')
    .replace(WHITE_SPACE_REGEX, ' ');

  return decodeEntities(sanitizedText);
};
